import {useCallback} from "react";
import {useQueryClient} from "@tanstack/react-query";
import {useSetRecoilState} from "recoil";
import {stateApplicationHash, stateIsExternalLoad, stateSelectedElements} from "../data/atoms";
import {generateHash} from "../utils/ApplicationUtils";

export const useBuilderUpdateExternal = () => {
    const queryClient = useQueryClient();
    const setApplicationHash = useSetRecoilState(stateApplicationHash);
    const setIsExternalLoad = useSetRecoilState(stateIsExternalLoad);
    const setSelected = useSetRecoilState(stateSelectedElements);

    const onUpdateExternal = useCallback((state) => {
        if (state) {
            setApplicationHash(generateHash());
            setIsExternalLoad(true);
            setSelected({...state});

            queryClient.resetQueries([]);
        }
    }, [queryClient, setApplicationHash, setIsExternalLoad, setSelected]);


    // useMount(() => {
    //     const state = window.__CONSTRUCTOR_STATE__;
    //
    //     if (state) {
    //         setIsExternalLoad(true);
    //
    //         setSelected({
    //             model: state.model || null,
    //             size: state.size || null,
    //             complectations: state.complectations || {},
    //             accesories: state.accesories || {},
    //         });
    //     }
    // });

    return {
        onUpdateExternal,
    }
};
